import BaseImage, { ImageProps as BaseProps } from 'react-bootstrap/Image'

export interface ImageProps extends BaseProps {}

export const Image = (props: ImageProps): JSX.Element => (
  <>
    <BaseImage {...props} />
  </>
)
